<template>
    <div class='fxn-body'>
        <div class="fxn-login-header">
            <div class="fxn-pull-left">
                <img src="../assets/img/fxn-login.png" alt="">
            </div>
            <div class="fxn-pull-right">Welcome to Login</div>
        </div>
        <!-- Login Header End -->
        <div class="fxn-login">
            <div class="fxn-login-wrap">
                <div class="fxn-login-img">
                    <img src="../assets/img/fxn-login-bg.png" alt="">
                </div>
                <div class="fxn-login-form">
                    <h3>M+贷后管理系统</h3>
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="账户密码登录" name="1">
                            <el-form @submit.native.prevent :model="LoginForm" :rules="LoginRules" ref="LoginForm">
                                <el-form-item prop="username">
                                    <el-input prefix-icon="iconfont iconperson" type="text" v-model.trim="LoginForm.username" autocomplete="off" placeholder="输入账号"></el-input>
                                </el-form-item>
                                <el-form-item prop="password">
                                    <el-input prefix-icon="iconfont iconunlock" type="password" v-model.trim="LoginForm.password" autocomplete="off" @keyup.enter.native="submitForm('LoginForm')" placeholder="输入密码"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-button type="primary" class="fxn-button-block" native-type="submit" @click="submitForm('LoginForm')">登录</el-button>
                        </el-tab-pane>
                        <!-- 账户密码登录 End -->
                        <!-- <el-tab-pane label="手机号登录" name="second">

                        </el-tab-pane> -->
                        <!-- 手机号登录 End -->
                    </el-tabs>
                </div>
            </div>
        </div>
        <!-- Login Wrap End -->
        <div class="fxn-login-footer">
            <p>为了更好的网站体验，建议您使用谷歌、火狐、360极速模式等高版本的浏览器！</p>
            <p>CopyRight &copy; 2019 深圳债卫士科技信息有限公司，官方客服400-000-7748 <span @click="toBeian">粤ICP备18144451号-2</span></p>
        </div>
        <!-- Login Footer End -->

        <!-- 实名认证 -->
        <el-dialog title="提示" :visible.sync="NoAuthentication" width="35%" :close-on-click-modal="true">
            <div class="fxn-text-center fxn-text-org fxn-font-size-18" v-if="idcard_status == 0">为加强合规作业管理、贯彻合法合规催收精神，首次注册登录用户者请进行实名认证，感谢配合！</div>
            <div class="fxn-text-center fxn-text-org fxn-font-size-18" v-if="idcard_status == 1">实名认证审核中，请稍等...</div>
            <div class="fxn-text-center fxn-text-org fxn-font-size-18" v-if="idcard_status == 3">您的实名认证信息审核不通过，请重新认证。</div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="NoAuthentication = false">取 消</el-button>
                <el-button v-show="idcard_status != 2" type="primary" @click="toAuthentication">去认证</el-button>
            </div>
        </el-dialog>
        <!-- 实名认证 End -->
    </div>
</template>

<script>
    export default {
        data(){
            return{
                activeName: '1',
                idcard_status: '',
				NoAuthentication: false,			//实名认证
                //登录较验
                LoginForm: {
                    username: '',
                    password: '',
                },
                LoginRules: {
                    username: [
                        { required: true, message: '输入账号', trigger: 'blur' },
                    ],
					password: [
                        { required: true, message: '输入密码', trigger: 'blur' },
                        { min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: 'blur' }
                    ]
                },
            }
        },
        methods:{
            //用户名登录
            submitForm(formName){
                this.$refs[formName].validate((valid) => {
					if(valid) {
                        this.post('/osapi/Login/Loginact',{
							username: this.LoginForm.username,
							password: this.LoginForm.password
                        })
                        .then( res=>{
                            let { msg, code} = res.data;
                            if (code !== 1) {
								this.$message({
									message: msg,
									type: 'error'
								});
							} else {
                                this.getUserInfo(res)
                            }
                        })
                    }
                })
            },

            //重置增值服务状态
            async resetService() {
                return new Promise( (resolve,reject) => {
                    this.get('/osapi/login/getservice')
                    .then( res => {
                        resolve(res);
                    }).catch( (error) => {
                        reject(error)
                    })
                })
            },

            //用户信息/状态
            async getUserInfo(res){
                let is_white = res.data.data.memberInfo.is_white;
                if(is_white == 1){
                    this.$message({
                        message: '白名单限制登录!请联系管理员!',
                        type: 'warning'
                    });
                }else{
                    localStorage.setItem('token', JSON.stringify(res.data.data.token));

                    let n = await this.resetService();        //重置增值服务状态 (获取到新的服务状态值才可往下执行)
                    let user = res.data.data;
                    Object.keys(n.data.data).forEach( (key1) => {        
                        for ( let i in user.memberInfo) {
                            if (key1 == i) {
                                user.memberInfo[i] = n.data.data[key1]   //将获取到的服务状态值覆盖现有的
                                break
                            }
                        }
                    })
                    localStorage.setItem('user',JSON.stringify(user));
                    this.$router.push({ path: '/' });
                    
                    if(!user.memberInfo.psd_upd_time || user.memberInfo.psd_upd_time === '0'){
                        localStorage.setItem('pass_status','1')
                        this.$router.push({ path: '/' });
                        return false
                    }
                    
                }
            },

            //去认证
			toAuthentication(){
				this.$router.push({ path: '/realName' });
			},

            //跳转备案
            toBeian(){
                window.open('http://www.beian.miit.gov.cn/');
            },

            //切换登录类型
            handleClick(){

            },
        },
        mounted(){
           
        },
        beforeCreate () {
            document.querySelector('body').setAttribute('style', 'background: #326fea;background: -webkit-linear-gradient(to right, #326fea, #2699f5); background: linear-gradient(to right, #326fea, #2699f5);')
        },
        beforeDestroy () {
            document.querySelector('body').removeAttribute('style','')
        }
    }
</script>

<style scoped>
   
</style>


// WEBPACK FOOTER //
// src/components/Login.vue